import React from 'react';
import { Helmet } from 'react-helmet-async';
import CommonHeader from '../Components/Headers/CommonHeader.jsx';
import AboutContent from '../Components/About/AboutContent';
import $ from 'jquery';

export default function About() {
  $('.popover').hide();

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Database Information</title>
        <meta name="description" content="Information about database statistics, attributes and metrics." />
        <link rel="canonical" href="/About" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="DISGENET: Database Information" />
        <meta
          name="twitter:description"
          content="Information about database statistics, attributes and metrics."
        />
        <meta name="twitter:image" content="../public/static/images/LOGO_DISGENET.svg" />

        {/* Tags for LinkedIn */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.disgenet.com/About" />
        <meta property="og:title" content="DISGENET: Database Information" />
        <meta
          property="og:description"
          content="Explore detailed information about database statistics, attributes, and metrics on DISGENET."
        />
        <meta property="og:image" content="../public/static/images/LOGO_DISGENET.svg" />
      </Helmet>
      <CommonHeader />
      <AboutContent />
    </React.Fragment>
  );
}
